'use client';

import ShowroomSection from "@/app/__to_be_integrated/_____components/showroom/Showroom";
import { MediaRef } from "@/app/__to_be_integrated/_____components/image/enhanced-image/types/types";
import { ShowroomProvider } from "@/app/__to_be_integrated/_____components/showroom/ShowroomContext";
import { useSitePhotoArchiveEditor } from "@/app/features/sites/photo-archive/contexts/SitePhotoArchiveEditorContext";
import { PhotoArchiveShowroomFrame } from "@/app/features/sites/photo-archive/ui/shared/PhotoArchiveFrames";

export default function PhotoArchiveShowroomEditable() {
    const {
        editable,
        updateEditable
    } = useSitePhotoArchiveEditor();

    if (!editable) {
        return null;
    }

    if (!editable.showroom) {
        return null;
    }

    const updateShowroomTitle = (title: string) => {
        updateEditable({
            showroom: {
                ...editable.showroom!,
                title
            }
        });
    }

    const updateShowroomSubtitle = (subtitle: string) => {
        updateEditable({
            showroom: {
                ...editable.showroom!,
                subtitle
            }
        });
    }

    const updateShowroomDescription = (description: string) => {
        updateEditable({
            showroom: {
                ...editable.showroom!,
                description
            }
        });
    }

    const updateShowroomImages = (images: MediaRef[]) => {
        updateEditable({
            showroom: {
                ...editable.showroom!,
                images
            }
        });
    }

    return (
        <PhotoArchiveShowroomFrame>
            <ShowroomProvider
                content={{
                    id: editable.showroom.documentId,
                    title: editable.showroom.title,
                    subtitle: editable.showroom.subtitle,
                    description: editable.showroom.description,
                    images: editable.showroom.images,
                }}
                isEditing={false}
                setTitle={updateShowroomTitle}
                setSubtitle={updateShowroomSubtitle}
                setDescription={updateShowroomDescription}
                setImages={updateShowroomImages}
            >
                <ShowroomSection />
            </ShowroomProvider>
        </PhotoArchiveShowroomFrame>
    );
}
